import type { TrendItemBasicInfoAllOfTwoCategory } from './trendItemBasicInfoAllOfTwoCategory';

/**
 * 트렌드 기본 정보
 */
export type TrendItemBasicInfoAllOfTwo = {
  category?: TrendItemBasicInfoAllOfTwoCategory;
  name: string;
};
